<template>
  <div class="mt-5">
    <h3 v-if="$route.params._id">게시글 수정 </h3>
    <h3 v-else>게시글 작성 </h3>
    <mdb-alert v-if="errors.length" color="danger">
      <ul class="mb-0">
        <li v-for="(error, index) in errors" :key="index">{{error}}</li>
      </ul>
    </mdb-alert>
    <form>
      <mdb-input label="제목" v-model="article.title" />
      <mdb-input label="작성자" v-if="article.writer" v-model="article.writer.name" class="w-30" disabled/>
      <div v-if="article.attach">
        첨부파일: <small color>삭제할 파일을 선택하세요.</small> <br/>
        <div class="custom-control custom-checkbox" v-for="(file, index) in article.attach" :key="index">
          <input type="checkbox" class="custom-control-input" :id="'attach' + index" :value="index" v-model="checkAttach" >
          <label class="custom-control-label" :for="'attach' + index"><mdb-icon icon="paperclip" /> {{file.orgFile}}</label>
        </div>
      </div>
      <div class="mt-3">
        <input type="file" class="w-50 underline" ref="attach" multiple @change="selectFiles">
      </div>
      <ul class = "list-unstyled">
        <li  v-for="(file, index) in fileInfos" :key="index"><mdb-icon icon="paperclip" /> {{file.name}} ({{file.size}})
        </li>
      </ul>
      <Editor api-key="bb6a9ok4gca5sz21rpraocwpvxacglub7ukxmzxm8plvzlkz" v-model="article.content" :init="editorInit"/>
    </form>
    <div class="text-center">
      <mdb-btn @click='$router.back()'><mdb-icon  icon="angle-left" /> 돌아가기</mdb-btn>
      <mdb-btn @click='onEdit' :disabled="!isOk"><mdb-icon  icon="check"/> 확인</mdb-btn>
    </div>
  </div>
</template>

<script>
import { mdbIcon, mdbBtn, mdbInput, mdbAlert } from 'mdbvue';
import { mapState, mapMutations, mapActions } from 'vuex';
import ActionType from '@/store/modules/article/ActionType.js';
import Editor from '@tinymce/tinymce-vue';
import { editorInit } from '@/views/common/config.js';
export default {
  name: 'BoardDetail',
  components: { mdbIcon, mdbInput, mdbBtn, mdbAlert, Editor },
  data: () => ({
    mode: 'UNKNOWN',
    article: {},
    editorInit: editorInit,
    checkAttach: [],
    fileInfos: [],
    errors: []
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training']),
    isOk () {
      return this.article && this.article.title
    }
  },
  methods: {
    selectFiles () {
      this.fileInfos = this.$refs.attach.files;
    },
    async onEdit () {
      if (confirm('저장할까요?')) {
        const form = new FormData();
        form.append('category', 'board');
        form.append('title', this.article.title);
        form.append('content', this.article.content);
        form.append('removeAttach', this.checkAttach);
        this.$refs.attach.files.forEach(f => form.append('attach', f))
        try {
          if (this.mode === 'EDIT') {
            form.append('_id', this.article._id);
            this.article = await this.article.save(form);
            this.$router.back(); // 수정
          } else { // 저장
            form.append('training', this.training._id);
            form.append('writer', this.article.writer._id);
            this.article = await this.article.save(form);
            this.$router.push({ name: 'StudentBoardPage' });
          }
        } catch (e) {
          this.errors = [];
          this.errors.push('수정에 실패했습니다.');
          console.log(e)
        }
      }
    },
    async load () {
      if (!this.profile && !this.profile.userId) return
      this.mode = this.$route.params._id ? 'EDIT' : 'NEW';
      if (this.mode === 'EDIT') { // 수정
        this.article = await this.$Article.get(this.$route.params._id);
      } else { // 새 글쓰기
        this.article = this.$Article.create('board', this.profile)
      }
    }
  },
  watch: { profile: 'load' },
  created () { this.load() }
}
</script>
